import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { getRoles, hasAdminRole } from '../components/RolesDisplay';

export function useAdminAccess() {
  const { instance, accounts } = useMsal();
  const account = accounts?.[0] || null;
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminLoading, setAdminLoading] = useState(true);
  const [adminError, setAdminError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const resolveAdmin = async () => {
      if (!instance || !account) {
        if (!cancelled) {
          setIsAdmin(false);
          setAdminError(null);
          setAdminLoading(false);
        }
        return;
      }

      setAdminLoading(true);
      try {
        const roles = await getRoles(instance, account);
        if (!cancelled) {
          setIsAdmin(hasAdminRole(roles));
          setAdminError(null);
        }
      } catch (err) {
        console.error('useAdminAccess: failed to evaluate admin role', err);
        if (!cancelled) {
          setIsAdmin(false);
          setAdminError(err);
        }
      } finally {
        if (!cancelled) {
          setAdminLoading(false);
        }
      }
    };

    resolveAdmin();

    return () => {
      cancelled = true;
    };
  }, [instance, account]);

  return { isAdmin, adminLoading, adminError };
}

export default useAdminAccess;
